import { TechDocWizardPage } from '../containers/pages';
import { PRIMERA_VIDEO_URL } from '../constants';
import { powerupInit } from './primeraPagesConfigCommon';
import { gettingStarted } from './nimblePrimeraPageConfigComm';

export const pagesConfig = [
  ...gettingStarted(),
  {
    path: '/physical-install',
    menuText: 'physicalInstallation',
    exact: true,
    redirectTo: '/physical-install/unbox',
    submenuItems: [
      {
        path: '/physical-install/unbox',
        menuText: 'unbox',
        exact: true,
        redirectTo: '/physical-install/unbox/1',
      },
      {
        path: '/physical-install/unbox/:step',
        exact: true,
        component: TechDocWizardPage,
        pageName: 'unbox',
        pageProps: {
          steps: [
            {
              videoUrl: PRIMERA_VIDEO_URL.FACTORY_UNBOX_STEP1,
            },
            {
              videoUrl: PRIMERA_VIDEO_URL.FACTORY_UNBOX_STEP2,
            },
            {
              videoUrl: PRIMERA_VIDEO_URL.FACTORY_UNBOX_STEP3,
            },
            {
              videoUrl: PRIMERA_VIDEO_URL.FACTORY_UNBOX_STEP4,
            },
          ],
        },
      },
      {
        path: '/physical-install/cable',
        menuText: 'cable',
        exact: true,
        redirectTo: '/physical-install/cable/1',
      },
      {
        path: '/physical-install/cable/:step',
        exact: true,
        component: TechDocWizardPage,
        pageName: 'cable',
        pageProps: {
          steps: [
            {
              videoUrl: PRIMERA_VIDEO_URL.FACTORY_CABLE_STEP1,
            },
            {
              videoUrl: PRIMERA_VIDEO_URL.FACTORY_CABLE_STEP2,
            },
            {
              videoUrl: PRIMERA_VIDEO_URL.FACTORY_CABLE_STEP4,
            },
          ],
        },
      },
    ],
  },
  ...powerupInit,
];
